// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","529":"cgv","871":"legal"}[chunkId] + "." + {"443":"7f7b1f59","529":"53035577","871":"0fbfa024"}[chunkId] + ".js";
};